import {
  DocumentOrganizationKeys,
  FilterOptionKeys,
  GoalFilterDocument,
} from '@griply/types';
import { Goal } from 'shared/types/goal';
import { LifeArea } from 'shared/types/life-area';
import { GoalSortingMode, GroupByMode } from 'shared/types/sorting-mode';

export const getDefaultGoalFilterDocument = (
  lifeArea: LifeArea | undefined,
  goals: Goal[],
): GoalFilterDocument => {
  const base: GoalFilterDocument = lifeArea?.goalFilterDocument ?? {
    [DocumentOrganizationKeys.GroupByMode]: GroupByMode.None,
  };

  return {
    ...base,
    [DocumentOrganizationKeys.GroupByMode]:
      base.groupByMode ?? GroupByMode.None,
    [DocumentOrganizationKeys.SortingMode]:
      base.sortingMode ??
      lifeArea?.goalSortingMode ??
      GoalSortingMode.StartDate,
    [DocumentOrganizationKeys.Filters]: {
      ...(base[DocumentOrganizationKeys.Filters] ?? {}),
      [FilterOptionKeys.LifeArea]: {
        include: [lifeArea?.id ?? ''],
      },
    },
    [DocumentOrganizationKeys.CollapsedSections]:
      base.collapsedSections ??
      lifeArea?.collapsedGoals ??
      goals.map(({ id }) => id),
  };
};
